import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AccountFormatService } from 'src/app/services/account-format.service';
import { LoadingService } from 'src/app/services/loading.service';
import { TagPage } from 'src/app/store/actions/ui.actions';
import { OnboardingProductsStore } from 'src/app/store/store';

@Component({
  selector: 'app-abr-light',
  templateUrl: './abr-light.component.html',
  styleUrls: ['./abr-light.component.scss']
})
export class AbrLightComponent implements OnInit {

  pageTitle: string;

  constructor(
    private accountFormatService: AccountFormatService,
    public loadingService: LoadingService,
    private store: Store<OnboardingProductsStore.AppState>
  ) { }

  ngOnInit(): void {
    this.accountFormatService.getAccountNameFromAssets().subscribe((accountTitle) => {
      this.pageTitle = accountTitle;
    });
    setTimeout(() => {
      this.loadingService.loading = false;
    }, 100);
    this.store.dispatch(TagPage({text: 'abrLight'}));
  }

  checkOffices() {
    window.open('https://www.bancofalabella.pe/sucursales', '_blank');
  }

}
